import Utils from "../../utils/Utils";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
export default class FreeSpinReel {
    constructor(scene, x, y, index, orientation) {
        this.index = 0;
        this.spinProgressValue = { value: 0 };
        this.spinAnimationDuration = 50;
        this.virtualReelPosition = 0;
        this.realMemoIndex = 0;
        this.freeSpinCells = [];
        this.spinMainButtonTween = null;
        this.scene = scene;
        this.gameLogicVariableManager = window.GameLogicVariableManager;
        this.gameDataManager = window.GameDataManager;
        this.index = index;
        this.numOfCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL;
        this.numOfExtraCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        this.lastCellIndex = ResourcesDispatcher.GAME_CONSTANTS.LAST_CELL_INDEX;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.container = this.scene.add.container(x, y);
        this.createReelMask(orientation);
        // this.freeSpinCells = freeSpinCellCreation.cells;
        // this.cellPosition = freeSpinCellCreation.cellPositions;
    }
    setFreeSpinCellCreation(freeSpinCellCreation) {
        this.freeSpinCells = freeSpinCellCreation.cells;
        this.cellPosition = freeSpinCellCreation.cellPositions;
    }
    createReelMask(orientation) { }
    setIndex(index) {
        this.index = index;
    }
    getIndex() {
        return this.index;
    }
    getContainer() {
        return this.container;
    }
    resetFlagsAndCounters() {
        this.turnOn();
        this.virtualReelPosition = Utils.getRandomInt(0, this.scene.freeSpinGameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.stopped = false;
        this.forced = false;
        this.canStop = false;
        this.mustStop = false;
        this.mustEnableStop = false;
        this.realMemoIndex = 0;
        this.removeStopEvent();
    }
    turnOn() {
        this.freeSpinCells.forEach((cell) => {
            cell.turnOn();
        });
    }
    turnOff() {
        this.freeSpinCells.forEach((cell) => {
            cell.turnOff();
        });
    }
    resetCellsPositions() {
        this.freeSpinCells.forEach((cell, index) => {
            cell.getContainer().y = (this.cellSize.height * index) - (this.cellSize.height / 2);
        });
    }
    reIndexCells() {
        let freeSpinCells = [];
        for (let i = 1; i < this.numOfCellsPerReel + this.numOfExtraCellsPerReel; i++) {
            freeSpinCells[i - 1] = this.freeSpinCells[i];
            this.freeSpinCells[i].setIndex(i - 1);
        }
        this.freeSpinCells[0].setIndex(this.lastCellIndex);
        freeSpinCells[this.lastCellIndex] = this.freeSpinCells[0];
        this.freeSpinCells = [];
        this.freeSpinCells = freeSpinCells;
    }
    configureFreeSpinTween() { }
    spin(mainButtonBackground) {
        this.spinProgress.play();
        if (mainButtonBackground) {
            if (window.isButtonSpinning === false) {
                window.isButtonSpinning = true;
                this.spinMainButtonTween = Utils.spinMainButtonRotation(mainButtonBackground, this.scene);
            }
        }
    }
    bounce() { }
    removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }
        this.stopEvent = undefined;
    }
}
